export class UserToPlatformEntity {
    id;
    userId;
    platformId;

    constructor(id, userId, platformId) {
      this.id = id;
      this.userId = userId;
      this.platformId = platformId;
    }
  }
  